import _taggedTemplateLiteral from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: inline-block;\n        position: relative;\n        width: 400px;\n        height: 42px;\n        font-family: sans-serif;\n      }\n    \n      :host(.pending) {\n        opacity: 0;\n      }\n    \n      svg {\n        display: block;\n      }\n    \n      path {\n        stroke: currentColor;\n        stroke-width: 0.7;\n        fill: transparent;\n      }\n    \n      .overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        pointer-events: none;\n      }\n    \n      .labelContainer {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    \n      .progressLabel {\n        color: var(--wired-progress-label-color, #000);\n        font-size: var(--wired-progress-font-size, 18px);\n      }\n    \n      .progbox {\n        fill: var(--wired-progress-color, rgba(0, 0, 200, 0.1));\n        stroke-opacity: 0.6;\n        stroke-width: 0.4;\n      }\n    </style>\n    <div class=\"overlay\">\n      <svg id=\"svg\"></svg>\n    </div>\n    <div class=\"overlay labelContainer\">\n      <div class=\"progressLabel\">", "</div>\n    </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { LitElement, html } from '@polymer/lit-element/lit-element.js';
import { wired } from 'wired-lib/wired-lib.js';
export var WiredProgress =
/*#__PURE__*/
function (_LitElement) {
  _inherits(WiredProgress, _LitElement);

  _createClass(WiredProgress, null, [{
    key: "properties",
    get: function get() {
      return {
        value: Number,
        min: Number,
        max: Number,
        percentage: Boolean
      };
    }
  }]);

  function WiredProgress() {
    var _this;

    _classCallCheck(this, WiredProgress);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WiredProgress).call(this));
    _this.percentage = false;
    _this.max = 100;
    _this.min = 0;
    _this.value = 0;
    return _this;
  }

  _createClass(WiredProgress, [{
    key: "_createRoot",
    value: function _createRoot() {
      var root = this.attachShadow({
        mode: 'open'
      });
      this.classList.add('pending');
      return root;
    }
  }, {
    key: "_render",
    value: function _render() {
      return html(_templateObject(), this._getProgressLabel());
    }
  }, {
    key: "_getProgressLabel",
    value: function _getProgressLabel() {
      if (this.percentage) {
        if (this.max == this.min) {
          return '%';
        } else {
          var pct = Math.floor((this.value - this.min) / (this.max - this.min) * 100);
          return pct + "%";
        }
      } else {
        return "" + this.value;
      }
    }
  }, {
    key: "_clearNode",
    value: function _clearNode(node) {
      while (node.hasChildNodes()) {
        node.removeChild(node.lastChild);
      }
    }
  }, {
    key: "_didRender",
    value: function _didRender() {
      var svg = this.shadowRoot.getElementById('svg');

      this._clearNode(svg);

      var s = this.getBoundingClientRect();
      svg.setAttribute("width", s.width);
      svg.setAttribute("height", s.height);
      wired.rectangle(svg, 0, 0, s.width, s.height);
      var pct = 0;

      if (this.max > this.min) {
        pct = (this.value - this.min) / (this.max - this.min);
        var progWidth = s.width * Math.max(0, Math.min(pct, 100));
        var progBox = wired.polygon(svg, [[0, 0], [progWidth, 0], [progWidth, s.height], [0, s.height]]);
        progBox.classList.add("progbox");
      }

      this.classList.remove('pending');
    }
  }]);

  return WiredProgress;
}(LitElement);
customElements.define('wired-progress', WiredProgress);